import $ from 'jquery';
import {
	getSelectedGatewayComponentName,
	getSelectedPaymentBox,
	hostedOverrideActive,
	isPayForOrder,
	isPayoneerGatewaySelected,
	payoneerGateways,
	setHostedOverride,
	submitOrderPayViaAjax,
	getLongId
} from './src/util/woocommerce';
import { createSdk } from './src/util/sdk';
import { applyComponentListChange, mountComponents } from './src/util/components';

document.addEventListener(
	'DOMContentLoaded',
	function () {
		const $checkoutForm = $( 'form.checkout' );
		const $orderReviewForm = $( '#order_review' );
		/**
		 * We may not track droppedInComponents in the future. WebSDK instance has dropInComponents
		 * property with the same components, although the keys are different.
		 * But now this is not a part of the public API, so it is better to not rely on that until it
		 * is guaranteed.
	    */
		const droppedInComponents = {};
		let sdk = null;
		let longId = null;

		const onSdkError = ( checkout, component, data ) => {
			const { onErrorRefreshFragmentFlag } = window.PayoneerData;
			console.error( "WebSDK error:", { checkout, component, data } );

			//Only act on expired session or system failure, for anything else a refresh won't resolve the error.
			if ( ! ["EXPIRED_SESSION", "SYSTEM_FAILURE"].includes(data?.interaction?.reason) ) {
				//Re-enable hosted override so we don't block the checkout flow completely.
				setHostedOverride( true );
				return true;
			}

			if ( isPayForOrder() ) {
				const url = new URL( document.location );
				url.searchParams.set( window.PayoneerData.payOrderErrorFlag, true );
				window.location.href = url.toString();
				return false;
			}

			let errorFlag = document.querySelector( `input[name="${onErrorRefreshFragmentFlag}"]` );
			if ( errorFlag ) {
				errorFlag.value = 'true';
			}

			$( document.body ).trigger( 'update_checkout' );
		};

		const onComponentListChange = ( sdk, changeInfo ) => {
			applyComponentListChange( sdk, changeInfo, droppedInComponents );
			mountComponents(droppedInComponents, sdk);
		}

		/**
		 * Create SDK instance if not created.
		 * Mount components.
		 *
		 * We mount them in the `onComponentListChange` callback and that is the main place for
		 * components mounting. But we need to mount them here as well because fragment update
		 * removes DOM elements with mounted components. If there were no components list
		 * change, then `onComponentListChange` will not be triggered, so our mounting there
		 * will not be called. As a result, we will have no mounted components after fragments
		 * update.
		 */
		const onUpdatedCheckout = async () => {
			if (! sdk ) {
				sdk = await createSdk( onSdkError, onComponentListChange ).catch( err => {
					console.error( "WebSDK creation error:", err );
					setHostedOverride( true )
				} );
				if (sdk.state == 'ERROR') {
					setHostedOverride(true);
					return
				}
			}
			mountComponents(droppedInComponents, sdk); // to mount pre-loaded previews
			setHostedOverride(false);
			sdk.updateLongId(getLongId());
		}

		const startPayment = () => {
			const selectedComponentName = getSelectedGatewayComponentName();
			if(! selectedComponentName) {
				console.log(
					'Cannot find component name for selected payment gateway. Switching to the HPP.'
				);
			};

			const componentToPayWith = droppedInComponents[selectedComponentName];

			if(! componentToPayWith ) {
				console.log(
					'Cannot find component for selected payment gateway.'
				);
				//todo: improve fallback with preselection to make only selected payment available


			}

			if(typeof componentToPayWith.pay !== 'function') {
				console.error(
					`Selected component ${selectedComponentName} doesn't support the 'pay' method.`
				);
			}

			componentToPayWith.pay();
		};

		/**
		 * Cannot use native event listener for events dispatched by jQuery
		 * https://github.com/jquery/jquery/issues/3347
		 */
		$( document.body ).on( 'updated_checkout', onUpdatedCheckout );

		$checkoutForm.on( 'checkout_place_order_success', ( e, result ) => {
			if ( !isPayoneerGatewaySelected() || !hostedOverrideActive() ) {
				return;
			}
			startPayment();
			//Override default redirect to hosted payment page
			result.redirect = '#payoneer-redirect';

			/**
			 * Create a timeout that races the SDK's payment handling.
			 * If the handling is not done after 1,5 second, it unblocks
			 * the checkout form and scrolls the users to the payment fields
			 * because probably there is an error displayed there
			 *
			 * This is done since the SDK does not have any validation callback
			 * or Promise we could attach to.
			 */
			setTimeout( () => {
				$checkoutForm.removeClass( 'processing' ).unblock();
				$.scroll_to_notices(
					$( getSelectedPaymentBox() )
				);
			}, 1500 );

			return true;
		} );

		$orderReviewForm.on( 'submit', ( e ) => {
			if ( !isPayoneerGatewaySelected() || !hostedOverrideActive() ) {
				return;
			}

			e.preventDefault();
			e.stopImmediatePropagation();

			submitOrderPayViaAjax( $orderReviewForm )
				.then( () => startPayment() )
				.catch( () => {
					/**
					 * Reloading enables us to see error messages added via wc_add_notice()
					 * Scrolling up makes sure the notices are in the viewport after the refresh
					 */
					window.scrollTo( 0, 0 );
					window.location.reload();
				} );
		} );

		/**
		 * No fragment update on 'order-pay'. So we manually initialize our widget
		 * and listen to the native JS change event for the radio button
		 */
		if ( isPayForOrder() ) {
			onUpdatedCheckout();
		}
	},
	false,
);
